import { ModalEls } from 'common/modalEls.js';
import React, { useCallback, useContext, useEffect } from 'react';
import { PageChangeContext } from 'utilities/hooks/page-change-context.js';
import { getDocument } from 'utilities/window.js';
import { INTERSTITAL_WRAPPER } from './hook/interstitial-hook.js';

const createDiv = () => {
  const lclDocument = getDocument();
  if (lclDocument) {
    const divEl = lclDocument.createElement('div');
    divEl.className = INTERSTITAL_WRAPPER;
    return divEl;
  }
  return null;
};

/**
 * Appends Interstitial Container to Modal In Page Template
 * Adds when mounted / or page change
 * Removes when unmounted / or page change
 */
export const InterstitialPortalAddRemoveModalFromInterstitialContainer = ({
  displayOncePerSession,
}: {
  displayOncePerSession: boolean;
}): {
  interstitialContainerEl: React.MutableRefObject<HTMLDivElement | null>;
} => {
  const interstitialContainerEl = React.useRef<HTMLDivElement | null>(createDiv());
  const { pageUrlChanged: pageChange } = useContext(PageChangeContext);

  const { modalContent } = ModalEls({});

  const appendInterstitialContainerToModal = useCallback(() => {
    if (interstitialContainerEl.current) {
      modalContent.current?.appendChild(interstitialContainerEl.current);
    }
  }, [modalContent, interstitialContainerEl]);

  const removeInterstitialContainerFromModal = useCallback(() => {
    if (interstitialContainerEl.current) {
      if (modalContent.current?.contains(interstitialContainerEl.current)) {
        modalContent.current?.removeChild(interstitialContainerEl.current);
      }
    }
  }, [modalContent, interstitialContainerEl]);

  useEffect(() => {
    if (displayOncePerSession) {
      if (!pageChange) {
        // console.log('Adding Interstitial Container To Modal');
        appendInterstitialContainerToModal();
      }
    } else {
      // console.log('Adding Interstitial Container To Modal');
      appendInterstitialContainerToModal();
    }
    return () => {
      // console.log('Removing Interstitial Container From Modal');
      removeInterstitialContainerFromModal();
    };
  }, [appendInterstitialContainerToModal, removeInterstitialContainerFromModal, pageChange, displayOncePerSession]);

  return { interstitialContainerEl };
};
